<template>
  <va-dropdown
    class="profile-dropdown"
    v-model="isShown"
    boundary-body
    offset="0, 16px"
  >
    <span
      class="profile-dropdown__anchor"
      slot="anchor"
      :style="{ color: $themes.primary }"
    >
      <slot />
      <va-icon
        class="pa-1"
        :name="`fa ${isShown ? 'fa-angle-up' : 'fa-angle-down'}`"
      />
    </span>

    <div class="profile-dropdown__content pl-4 pr-4 pt-2 pb-2">
      <template v-for="option in options">
        <!-- Logout: executa ação -->
        <button
          v-if="option.name === 'logout'"
          :key="option.name"
          type="button"
          class="profile-dropdown__item pt-1 pb-1 mt-2 mb-2"
          @click="handleLogout(option)"
        >
          {{ $t(`user.${option.name}`) }}
        </button>

        <!-- Demais itens: navegação normal -->
        <router-link
          v-else
          :key="option.name"
          :to="{ name: option.redirectTo }"
          class="profile-dropdown__item pt-1 pb-1 mt-2 mb-2"
          @click.native="isShown = false"
        >
          {{ $t(`user.${option.name}`) }}
        </router-link>
      </template>
    </div>
  </va-dropdown>
</template>

<script>
// Se você usa js-cookie, descomente:
import Cookies from "js-cookie"

export default {
  name: "profile-section",
  data() {
    return { isShown: false }
  },
  props: {
    options: {
      type: Array,
      default: () => [{ name: "logout", redirectTo: "login" }],
    },
  },
  methods: {
    async handleLogout(option) {
      // 1) Limpa autenticação (ajuste para o seu cenário)
      Cookies.remove("admin-logged")
      Cookies.remove("user")
      localStorage.removeItem("token")
      localStorage.removeItem("user")

      // 2) Fecha dropdown e navega
      this.isShown = false

      // Use replace para evitar "voltar" pro app logado
      if (option && option.redirectTo) {
        await this.$router.replace({ name: option.redirectTo })
      } else {
        await this.$router.replace({ name: "login" })
      }
    },
  },
}
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__anchor {
    color: $vue-green;
  }

  .va-dropdown-popper__anchor {
    display: flex;
    justify-content: flex-end;
  }

  &__content {
    background-color: $dropdown-background;
    box-shadow: $gray-box-shadow;
    border-radius: 0.5rem;
    width: 8rem;
  }

  &__item {
    display: block;
    color: $vue-darkest-blue;

    &:hover,
    &:active {
      color: $vue-green;
    }
  }

  /* importante: botão precisa parecer link */
  button.profile-dropdown__item {
    width: 100%;
    text-align: left;
    background: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
